
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
      this.wholesalePricingContainer = this.closest('product-info')?.querySelector('[data-wholesale-pricing]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      if (this.wholesalePricingContainer) {
        this.onWholesaleSubmitHandler();
        return;
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
    
      //Added to generate selling plan add to cart response
      const sellingPlanId = window.getCurrentSellingPlanId();
      formData.append("selling_plan", sellingPlanId);
      
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    onWholesaleSubmitHandler() {
      const items = buildWholesaleItemsFromContainer(this.wholesalePricingContainer);
      if (items.length === 0) return;

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      if (typeof window.getCurrentSellingPlanId === 'function') {
        const sellingPlanId = window.getCurrentSellingPlanId();
        if (sellingPlanId) formData.append('selling_plan', sellingPlanId);
      }

      items.forEach((item, index) => {
        formData.append(`items[${index}][id]`, String(item.id));
        formData.append(`items[${index}][quantity]`, String(item.quantity));
        if (!item.properties) return;
        Object.entries(item.properties).forEach(([key, value]) => {
          if (value === undefined || value === null || value === '') return;
          formData.append(`items[${index}][properties][${key}]`, String(value));
        });
      });

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(async (response) => {
          const contentType = response.headers.get('content-type') || '';
          if (contentType.includes('application/json')) return response.json();

          const text = await response.text();
          if (isWholesaleDebugEnabled()) {
            console.log('[Wholesale Debug] cart/add non-json response', { status: response.status, contentType });
            console.log('[Wholesale Debug] cart/add non-json body (head)', text.slice(0, 400));
          }

          if (text.includes('Your connection needs to be verified')) {
            submitWholesaleItemsAsForm(items);
            return null;
          }

          try {
            return JSON.parse(text);
          } catch {
            throw new Error('Unexpected cart/add response');
          }
        })
        .then((response) => {
          if (!response) return;
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: null, errors: response.description, message: response.message });
            this.handleErrorMessage(response.description || response.message);
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: null });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  renderCartFromAddResponse(this.cart, response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            renderCartFromAddResponse(this.cart, response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function isWholesaleDebugEnabled() {
  try {
    const url = new URL(window.location.href);
    if (url.searchParams.get('wholesaleDebug') === '1') return true;
  } catch {
  }
  try {
    return window.localStorage.getItem('wholesaleDebug') === '1';
  } catch {
    return false;
  }
}

function parseJSONFromScriptTag(container, selector) {
  const el = container.querySelector(selector);
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch {
    return null;
  }
}

function toCents(value) {
  if (value === undefined || value === null) return null;
  if (typeof value === 'object' && value.amount !== undefined && value.amount !== null) {
    return toCents(String(value.amount));
  }
  if (typeof value === 'number') {
    if (Number.isInteger(value) && value > 1000) return value;
    return Math.round(value * 100);
  }

  if (typeof value !== 'string') return null;
  const normalized = value.replace(/[^0-9.]/g, '');
  if (!normalized) return null;
  if (normalized.includes('.')) return Math.round(parseFloat(normalized) * 100);
  const intVal = parseInt(normalized, 10);
  if (Number.isNaN(intVal)) return null;
  if (intVal > 1000) return intVal;
  return intVal * 100;
}

function getTierMin(tier) {
  const raw = tier?.min ?? tier?.min_qty ?? tier?.from ?? tier?.qty_min ?? tier?.quantity_min;
  const parsed = parseInt(raw, 10);
  return Number.isFinite(parsed) ? parsed : 0;
}

function getTierMax(tier) {
  const raw = tier?.max ?? tier?.max_qty ?? tier?.to ?? tier?.qty_max ?? tier?.quantity_max;
  if (raw === undefined || raw === null || raw === '') return null;
  const parsed = parseInt(raw, 10);
  return Number.isFinite(parsed) ? parsed : null;
}

function getTierPrice(tier, size) {
  if (tier?.prices && Object.prototype.hasOwnProperty.call(tier.prices, size)) return tier.prices[size];
  if (Object.prototype.hasOwnProperty.call(tier, size)) return tier[size];
  return null;
}

function formatMoneyCents(cents, currency) {
  const amount = (cents || 0) / 100;
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount);
  } catch {
    return amount.toFixed(2);
  }
}

function setWholesaleButtonState(container, totalQty) {
  const productInfo = container.closest('product-info');
  if (!productInfo) return;
  const submitButton = productInfo.querySelector('button[type="submit"][name="add"]');
  if (!submitButton) return;

  if (submitButton.dataset.wholesaleBaseDisabled === undefined) {
    submitButton.dataset.wholesaleBaseDisabled = submitButton.disabled ? 'true' : 'false';
  }

  const baseDisabled = submitButton.dataset.wholesaleBaseDisabled === 'true';
  submitButton.disabled = baseDisabled || totalQty <= 0;
}

function recalcWholesale(container) {
  const state = container._wholesaleState;
  if (!state) return;

  const qtyInputs = container.querySelectorAll('input[data-wholesale-variant-id]');
  let totalQty = 0;
  const qtyBySize = new Map();

  qtyInputs.forEach((input) => {
    const qty = Math.max(0, parseInt(input.value || '0', 10) || 0);
    const size = input.dataset.wholesaleSize || '';
    qtyBySize.set(size, qty);
    totalQty += qty;
  });

  const tiers = state.tiers;
  let selectedTierIndex = -1;
  if (totalQty > 0) {
    for (let i = 0; i < tiers.length; i++) {
      const min = getTierMin(tiers[i]);
      const max = getTierMax(tiers[i]);
      const matches = totalQty >= min && (max === null || totalQty <= max);
      if (matches) selectedTierIndex = i;
    }

    if (selectedTierIndex === -1) {
      for (let i = 0; i < tiers.length; i++) {
        const min = getTierMin(tiers[i]);
        if (totalQty >= min) selectedTierIndex = i;
      }
    }
  }

  const tierRows = container.querySelectorAll('tr[data-wholesale-tier]');
  tierRows.forEach((row) => row.classList.remove('is-selected'));
  if (selectedTierIndex >= 0) {
    const row = container.querySelector(`tr[data-wholesale-tier][data-tier-index="${selectedTierIndex}"]`);
    if (row) row.classList.add('is-selected');
  }

  let subtotalCents = 0;
  if (selectedTierIndex >= 0) {
    const tier = tiers[selectedTierIndex];
    state.sizes.forEach((size) => {
      const qty = qtyBySize.get(size) || 0;
      if (qty <= 0) return;
      const priceValue = getTierPrice(tier, size);
      const unitPriceCents = toCents(priceValue);
      if (unitPriceCents === null) return;
      subtotalCents += qty * unitPriceCents;
    });
  }

  const totalQtyEl = container.querySelector('[data-wholesale-total-qty]');
  if (totalQtyEl) totalQtyEl.textContent = String(totalQty);

  const totalPriceEl = container.querySelector('[data-wholesale-total-price]');
  if (totalPriceEl) totalPriceEl.textContent = formatMoneyCents(subtotalCents, state.currency);

  container.dataset.wholesaleTotalQty = String(totalQty);
  container.dataset.wholesaleSelectedTierIndex = String(selectedTierIndex);

  if (selectedTierIndex >= 0) {
    const tier = tiers[selectedTierIndex];
    const min = getTierMin(tier);
    const max = getTierMax(tier);
    container.dataset.wholesaleTierLabel = max === null ? `${min}+` : `${min}-${max}`;
  } else {
    container.dataset.wholesaleTierLabel = '';
  }

  setWholesaleButtonState(container, totalQty);
}

function buildWholesalePricingTable(container) {
  const tiersRaw = parseJSONFromScriptTag(container, '[data-wholesale-tiers]');
  const sizes = parseJSONFromScriptTag(container, '[data-wholesale-sizes]');
  const variants = parseJSONFromScriptTag(container, '[data-wholesale-variants]');
  const currency = container.dataset.currency || 'USD';
  const sizeOptionIndex = parseInt(container.dataset.sizeOptionIndex || '1', 10);
  const wholesaleType = container.dataset.wholesaleType || '';

  let tiers = tiersRaw;
  if (typeof tiersRaw === 'string') {
    try {
      tiers = JSON.parse(tiersRaw);
    } catch {
      tiers = null;
    }
  }

  if (!Array.isArray(sizes) || !Array.isArray(variants)) return;

  const variantBySize = new Map();
  variants.forEach((variant) => {
    const size = variant?.[`option${sizeOptionIndex}`];
    if (!size || variantBySize.has(size)) return;
    variantBySize.set(size, variant);
  });

  if (!Array.isArray(tiers)) {
    const tierBrackets = [
      { min: 1, max: 5 },
      { min: 6, max: 12 },
      { min: 13, max: null }
    ];

    tiers = tierBrackets.map((bracket, tierIndex) => {
      const prices = {};
      sizes.forEach((size) => {
        const variant = variantBySize.get(String(size));
        if (!variant) return;
        const tierArray = wholesaleType === 'special' ? variant.specialTierPrices : variant.regularTierPrices;
        const tierValue = Array.isArray(tierArray) ? tierArray[tierIndex] : null;
        const amount = tierValue && typeof tierValue === 'object' && tierValue.amount !== undefined ? String(tierValue.amount) : tierValue;
        if (amount === null || amount === undefined || amount === '') return;
        prices[String(size)] = amount;
      });

      return { min: bracket.min, max: bracket.max, prices };
    });
  }

  container._wholesaleState = { tiers, sizes, variants, variantBySize, currency, sizeOptionIndex };

  const tableWrap = container.querySelector('[data-wholesale-pricing-table]');
  if (!tableWrap) return;
  tableWrap.innerHTML = '';

  const table = document.createElement('table');
  table.className = 'wholesale-pricing__table';

  const thead = document.createElement('thead');
  const headRow = document.createElement('tr');
  const emptyTh = document.createElement('th');
  emptyTh.textContent = '';
  headRow.appendChild(emptyTh);
  sizes.forEach((size) => {
    const th = document.createElement('th');
    th.textContent = String(size);
    headRow.appendChild(th);
  });
  thead.appendChild(headRow);
  table.appendChild(thead);

  const tbody = document.createElement('tbody');

  tiers.forEach((tier, index) => {
    const min = getTierMin(tier);
    const max = getTierMax(tier);
    const label = max === null ? `${min}+` : `${min}-${max}`;

    const row = document.createElement('tr');
    row.dataset.wholesaleTier = 'true';
    row.dataset.tierIndex = String(index);

    const th = document.createElement('th');
    th.textContent = label;
    row.appendChild(th);

    sizes.forEach((size) => {
      const td = document.createElement('td');
      const priceValue = getTierPrice(tier, String(size));
      const priceCents = toCents(priceValue);
      td.textContent = priceCents === null ? '' : formatMoneyCents(priceCents, currency);
      row.appendChild(td);
    });

    tbody.appendChild(row);
  });

  const stockRow = document.createElement('tr');
  const stockTh = document.createElement('th');
  stockTh.textContent = 'Stock';
  stockRow.appendChild(stockTh);
  sizes.forEach((size) => {
    const td = document.createElement('td');
    const variant = variantBySize.get(String(size));
    const qty = variant?.inventory_quantity;
    td.textContent = qty === undefined || qty === null ? '' : String(qty);
    stockRow.appendChild(td);
  });
  tbody.appendChild(stockRow);

  const qtyRow = document.createElement('tr');
  const qtyTh = document.createElement('th');
  qtyTh.textContent = 'Quantity';
  qtyRow.appendChild(qtyTh);

  sizes.forEach((size) => {
    const td = document.createElement('td');
    const variant = variantBySize.get(String(size));
    const input = document.createElement('input');
    input.type = 'number';
    input.min = '0';
    input.step = '1';
    input.value = '0';
    input.inputMode = 'numeric';
    input.className = 'wholesale-pricing__qty-input';
    input.dataset.wholesaleSize = String(size);
    if (!variant || !variant.available) {
      input.disabled = true;
    } else {
      input.dataset.wholesaleVariantId = String(variant.id);
    }

    input.addEventListener('input', () => recalcWholesale(container));
    input.addEventListener('change', () => recalcWholesale(container));
    td.appendChild(input);
    qtyRow.appendChild(td);
  });

  tbody.appendChild(qtyRow);

  table.appendChild(tbody);
  tableWrap.appendChild(table);

  recalcWholesale(container);
}

function initWholesalePricing(container) {
  if (container.dataset.wholesaleInitialized === 'true') return;
  container.dataset.wholesaleInitialized = 'true';
  buildWholesalePricingTable(container);
}

function initWholesalePricingContainers() {
  document.querySelectorAll('[data-wholesale-pricing]').forEach(initWholesalePricing);
}

function buildWholesaleItemsFromContainer(container) {
  if (!container) return [];
  const qtyInputs = Array.from(container.querySelectorAll('input[data-wholesale-variant-id]'));
  const totalQty = parseInt(container.dataset.wholesaleTotalQty || '0', 10) || 0;
  const selectedTierIndex = parseInt(container.dataset.wholesaleSelectedTierIndex || '-1', 10);
  const tierLabel = container.dataset.wholesaleTierLabel || '';
  const wholesaleType = container.dataset.wholesaleType || '';

  if (totalQty <= 0 || selectedTierIndex < 0) return [];

  const items = [];
  qtyInputs.forEach((input) => {
    const qty = Math.max(0, parseInt(input.value || '0', 10) || 0);
    if (qty <= 0) return;
    const variantId = parseInt(input.dataset.wholesaleVariantId || '', 10);
    if (!variantId) return;

    items.push({
      id: variantId,
      quantity: qty,
      properties: {
        _wholesale_type: wholesaleType,
        _wholesale_tier: tierLabel,
        _wholesale_total_qty: totalQty
      }
    });
  });

  return items;
}

async function renderCartFromAddResponse(cart, response) {
  if (!cart) return;
  const tagName = cart.tagName ? cart.tagName.toLowerCase() : '';
  const isNotification = tagName === 'cart-notification';
  const isDrawer = tagName === 'cart-drawer';

  try {
    const sectionIds = cart.getSectionsToRender().map((section) => section.id);
    const hasSections = response?.sections && sectionIds.every((id) => response.sections[id]);
    const hasKey = !isNotification || Boolean(response?.key);

    if (hasSections && hasKey) {
      cart.renderContents(response);
      if (isDrawer) {
        const cartLink = document.querySelector('#cart-icon-bubble');
        if (cartLink && typeof cart.open === 'function') cart.open(cartLink);
      }
      return;
    }

    const basePath = window.location.pathname || routes.root_url || '/';
    const sectionsUrl = `${basePath}?sections=${encodeURIComponent(sectionIds.join(','))}`;
    const sectionsResponse = await fetch(sectionsUrl, { headers: { Accept: 'application/json' } });
    const sectionsContentType = sectionsResponse.headers.get('content-type') || '';
    let sections;
    if (sectionsContentType.includes('application/json')) {
      sections = await sectionsResponse.json();
    } else {
      const text = await sectionsResponse.text();
      try {
        sections = JSON.parse(text);
      } catch {
        if (isWholesaleDebugEnabled()) {
          console.log('[Wholesale Debug] sections non-json response', { contentType: sectionsContentType });
          console.log('[Wholesale Debug] sections non-json body (head)', text.slice(0, 400));
        }
        throw new Error('Unexpected sections response');
      }
    }

    const parsedState = { sections };
    if (isNotification) {
      const cartStateResponse = await fetch(`${routes.cart_url}.js`);
      const cartState = await cartStateResponse.json();
      const lastKey = cartState?.items?.length ? cartState.items[cartState.items.length - 1].key : null;
      if (lastKey) parsedState.key = lastKey;
    } else {
      parsedState.id = response?.id || null;
    }

    cart.renderContents(parsedState);
    if (isDrawer) {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (cartLink && typeof cart.open === 'function') cart.open(cartLink);
    }
  } catch (e) {
    console.error(e);
  }
}

function submitWholesaleItemsAsForm(items) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = routes.cart_add_url;

  items.forEach((item, index) => {
    const idInput = document.createElement('input');
    idInput.type = 'hidden';
    idInput.name = `items[${index}][id]`;
    idInput.value = String(item.id);
    form.appendChild(idInput);

    const qtyInput = document.createElement('input');
    qtyInput.type = 'hidden';
    qtyInput.name = `items[${index}][quantity]`;
    qtyInput.value = String(item.quantity);
    form.appendChild(qtyInput);

    if (item.properties) {
      Object.entries(item.properties).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return;
        const propInput = document.createElement('input');
        propInput.type = 'hidden';
        propInput.name = `items[${index}][properties][${key}]`;
        propInput.value = String(value);
        form.appendChild(propInput);
      });
    }
  });

  document.body.appendChild(form);
  form.submit();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWholesalePricingContainers);
} else {
  initWholesalePricingContainers();
}

document.addEventListener('shopify:section:load', initWholesalePricingContainers);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    if (!isWholesaleDebugEnabled()) return;
    const debugEls = document.querySelectorAll('[data-wholesale-debug]');
    debugEls.forEach((el) => {
      try {
        const payload = JSON.parse(el.textContent);
        console.log('[Wholesale Debug] Liquid', payload);
      } catch {
        console.log('[Wholesale Debug] Liquid (raw)', el.textContent);
      }
    });
    const wholesaleContainers = document.querySelectorAll('[data-wholesale-pricing]');
    console.log('[Wholesale Debug] Wholesale containers found:', wholesaleContainers.length);
    if (wholesaleContainers.length === 0) {
      console.log('[Wholesale Debug] No wholesale container rendered; show_wholesale_ui is false or price block not present.');
    }
  });
} else if (isWholesaleDebugEnabled()) {
  const debugEls = document.querySelectorAll('[data-wholesale-debug]');
  debugEls.forEach((el) => {
    try {
      const payload = JSON.parse(el.textContent);
      console.log('[Wholesale Debug] Liquid', payload);
    } catch {
      console.log('[Wholesale Debug] Liquid (raw)', el.textContent);
    }
  });
  const wholesaleContainers = document.querySelectorAll('[data-wholesale-pricing]');
  console.log('[Wholesale Debug] Wholesale containers found:', wholesaleContainers.length);
  if (wholesaleContainers.length === 0) {
    console.log('[Wholesale Debug] No wholesale container rendered; show_wholesale_ui is false or price block not present.');
  }
}
